export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6357.5e42586d.jpg";